export enum ReviewEntriesViewFilter {
  All = 'all',
  ToValidate = 'to_validate',
}
